import { render, staticRenderFns } from "./AccesoriesCard.vue?vue&type=template&id=1fbb8cc1&"
import script from "./AccesoriesCard.vue?vue&type=script&lang=js&"
export * from "./AccesoriesCard.vue?vue&type=script&lang=js&"
import style0 from "./AccesoriesCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports